import React, {ReactNode} from 'react';
import {Col, Row, Skeleton} from 'antd';

interface ViewProps {
    middleInputs?: number,
    largeInputs?: number,
    buttons?: number,
    active?: boolean
}

export const SkeletonForm: React.FunctionComponent<ViewProps> = (props) => {
    const middleInputs = props.middleInputs !== undefined ? props.middleInputs : 1;
    const largeInputs = props.largeInputs !== undefined ? props.largeInputs : 2;
    const buttons = props.buttons !== undefined ? props.buttons : 1;

    const active = props.active !== undefined ? props.active : true;

    const MidleSkeleton = React.useMemo(() => {
        const elements: ReactNode[] = [];

        for (let i = 0; i < middleInputs; i++) {
            elements.push((
                <Row key={`middle-${i}`} gutter={20} style={{width: '100%', marginBottom: 20, marginTop: 20}}>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                        <Skeleton.Input active={active} block/>
                    </Col>
                    <Col xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>
                        <Skeleton.Input active={active} block/>
                    </Col>
                </Row>
            ));
        }

        return elements;
    }, [middleInputs, active]);

    const LargeSkeleton = React.useMemo(() => {
        const elements: ReactNode[] = [];

        for (let i = 0; i < largeInputs; i++) {
            elements.push((
                <Row key={`arge-${i}`} gutter={20} style={{width: '100%', marginBottom: 20, marginTop: 20}}>
                    <Col span={24}>
                        <Skeleton.Input active={active} block/>
                    </Col>
                </Row>
            ));
        }

        return elements;
    }, [largeInputs, active]);

    const Buttons = React.useMemo(() => {
        if (buttons === 0) return null;

        const cols: ReactNode[] = [];
        let offset = {
            xs: 0,
            sm: 0,
            md: 24 -(buttons * 8),
            lg: 24 -(buttons * 6),
            xl: 24 -(buttons * 4)
        };

        for (let i = 0; i < buttons; i++) {
            cols.push(
                <Col xs={{ span: 24, offset: offset.xs }}
                     sm={{ span: 12, offset: offset.sm }}
                     md={{ span: 8, offset: offset.md }}
                     lg={{ span: 6, offset: offset.lg }}
                     xl={{ span: 4, offset: offset.xl }}
                     style={{marginTop: 10}}
                     key={`buttons-${i}`}
                >
                    <Skeleton.Button active={active} block/>
                </Col>
            );

            offset = {
                xs: 0,
                sm: 0,
                md: 0,
                lg: 0,
                xl: 0
            };
        }


        return (
            <Row gutter={20} style={{width: '100%', marginBottom: 20, marginTop: 20}}>
                {cols}
            </Row>
        );
    }, [buttons, active]);

    return (
        <React.Fragment>
            {MidleSkeleton}
            {LargeSkeleton}
            {Buttons}
        </React.Fragment>
    );
};
